export default __webpack_public_path__ + "static/media/thumbnail.1225df76.png";